<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :items="items" :title="title" style="margin-top: -30px"/>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="field_book_no">Field Book No. <span class="c-required">*</span></label>
                <input id="field_book_no" v-model="search_data.field_book_no" v-validate="{ required: true, regex: /^[0-9]+$/ }" class="form-control form-control-sm" name="field_book_no" placeholder="Search by field book no" type="number"/>
                <div class="invalid-feedback">Field book no is required</div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4" style="margin-top: 4px;">
                <label></label>
                <button class="btn btn-success btn-sm mt-3" @click.prevent="search()">Search</button>
              </div>
            </div>
          </form>
        </b-card>


        <b-card>
          <div v-if="trainees.total > 0" class="row mb-2">
            <div class="col-sm-6">
              <span class="badge badge-success mr-2">Total Search Data Found: {{ trainees.total }}</span>
            </div>
            <div  class="col-sm-6">
              <button type="button" id="export-table" @click="onexport"  class="btn btn-light float-right" style="margin-bottom:5px">Download Excel</button>
            </div>
          </div>

          <div class="scrollable-table table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped" id="titledExcel">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Book No.</th>
                <th>Sub Book No.</th>
                <th>Form No.</th>
                <th>Name</th>
                <th>NID</th>
                <th>Father Name</th>
                <th>Village</th>
                <th>Mouza</th>
                <th>Rep. Name</th>
                <th>Rep. Father/Husband Name</th>
                <th>Rep NID</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(trainee, index) in trainees.data" :key="index">
                <td>{{ trainees.from + index }}</td>
                <td>
                  <span v-for="(field_book, index) in trainee.field_books" :key="index">
                    {{ field_book.field_book_no }} {{ index + 1 !== trainee.field_books.length ? " |" : "" }}
                  </span>
                </td>
                <td>
                  <span v-for="(field_book, index) in trainee.field_books" :key="index">
                    {{ field_book.filed_book_sub_no }} {{ index + 1 !== trainee.field_books.length ? " |" : "" }}
                  </span>
                </td>
                <td>{{ trainee.form_no }}</td>
                <td>
                  <router-link :to="{name: 'traineeView',params: { trainee_id: trainee.id }}" tag="a"
                               target="_blank" title="Trainee Details">
                    {{ trainee.name }}
                  </router-link>
                </td>
                <td>{{ trainee.nid }}({{ trainee.id_type }})</td>
                <td>{{ trainee.father_husband_name }}</td>
                <td>{{ trainee.village.desc }}</td>
                <td>{{ trainee.mouza.desc }}</td>
                <td>{{ trainee.rep_name }}</td>
                <td>{{ trainee.rep_father_husband_name }}</td>
                <td><span v-if="trainee.rep_nid !== null">{{ trainee.rep_nid }}({{ trainee.rep_id_type }})</span></td>
              </tr>
              </tbody>
            </table>
          </div>

          <h5 v-if="trainees.total == 0" class="text-center text-secondary">
            No Data Found
          </h5>
          <div class="float-right">
            <pagination :data="trainees" :limit="2" @pagination-change-page="getResults"></pagination>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import XLSX from 'xlsx';

export default {
  page: {
    title: "Trainee List",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader},
  data() {
    return {
      title: "Search Trainee",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Trainee",
          active: true
        }
      ],
      trainees: {},
      search_data: {
        field_book_no: '',
      },
      flag: false,
    };
  },


  mounted() { },
  methods: {
     search() {
      this.$validator.validate().then(valid => {
        if (valid) {
           http.post("api/trainees/field-book/search", this.search_data).then(response => {
            if (!response.error) {
              this.flag = true;
              this.trainees = response.data.trainees;
            }
          });
        }
      });

    },
     getResults(page = 1) {
       http.post('api/trainees/field-book/search?page=' + page, this.search_data)
          .then(response => {
            this.flag = true;
            this.trainees = response.data.trainees;
          });
    },
    onexport(evt) {
      var tbl = document.getElementById('titledExcel');
      var wb = XLSX.utils.table_to_book(tbl);
      XLSX.writeFile(wb, "trainees.xlsx");
    }
  },
  computed: {
    userPermission() {
      return this.$store.state.user
    }
  },
  created() {
    this.$store.dispatch('getUserPermission')
  },
};
</script>
